// Typed env config. Vite injects `import.meta.env.VITE_*` at build time;
// reading through this module gives us one place to enforce that required
// values exist (throwing fast on misconfiguration is better than rendering
// a broken sign-in screen).

interface AdminConfig {
  apiUrl: string;
  cognito: {
    domain: string;
    clientId: string;
    redirectUri: string;
  };
}

function requireEnv(name: string): string {
  const value = import.meta.env[name] as string | undefined;
  if (!value) {
    throw new Error(
      `Missing required env var: ${name}. Copy .env.example to .env.local and fill it in.`,
    );
  }
  return value;
}

export const config: AdminConfig = {
  apiUrl: requireEnv('VITE_API_URL'),
  cognito: {
    domain: requireEnv('VITE_COGNITO_DOMAIN'),
    clientId: requireEnv('VITE_COGNITO_CLIENT_ID'),
    redirectUri: requireEnv('VITE_COGNITO_REDIRECT_URI'),
  },
};
